import { lazy } from "react";
import { Navigate } from "react-router-dom";
import { Layout } from "../components/Layouts";

const DashboardPage = lazy(() => import("../pages/dashboard"));
const ClinicalDashboardPage = lazy(() => import("../pages/clinical/dashboard"));
const ClinicalTransactionInfoPage = lazy(() => import("../pages/clinical/transaction"));

export default function privateRoutes() {
  return {
    element: <Layout />,
    children: [
      {
        path: "/dashboard/clinical",
        element: <ClinicalDashboardPage />,
        handle: { sessionType: "clinical" },
      },
      {
        path: "/transaction/:transactionId",
        element: <ClinicalTransactionInfoPage />,
        handle: { sessionType: "clinical" },
      },
      {
        path: "/",
        element: <DashboardPage />,
        handle: { sessionType: "general" },
      },
      {
        path: "*",
        element: <Navigate to="/" replace />,
        handle: { sessionType: "general" },
      },
    ],
  };
}